import React from 'react'
import { connect } from 'react-redux'
import { defaultTo } from 'lodash'

import { fetchDropOffAreas, clearDropOffAreas } from '../../actions/optionsApi'
import SearchSelect from '../../modules/select/SearchSelect'

class DropOffAreaSearchSelect extends React.Component {
  render() {
    return (
      <SearchSelect
        {...this.props}
        options={this.props.options}
        createQuery={defaultTo(this.props.createQuery, createQuery)}
        createLabel={createLabel}
        defaultValueQuery={defaultValueQuery}
        selectId="dropOffAreaOptions"
        selectStyle="textArea"
        preFetch
      />
    )
  }
}

const createQuery = (searchText) => ({
  q: searchText ? searchText.toLowerCase() : undefined,
})

const defaultValueQuery = (initialId) => ({
  _id: initialId,
})

const createLabel = (value) => value

export default connect(null, {
  fetchOptions: fetchDropOffAreas,
  clearOptions: clearDropOffAreas,
})(DropOffAreaSearchSelect)
